import { render, staticRenderFns } from "./EditarDados.vue?vue&type=template&id=cc5680c0&scoped=true&"
import script from "./EditarDados.vue?vue&type=script&lang=js&"
export * from "./EditarDados.vue?vue&type=script&lang=js&"
import style0 from "./EditarDados.vue?vue&type=style&index=0&id=cc5680c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5680c0",
  null
  
)

export default component.exports